define("ember-intl/index", ["exports", "ember-intl/services/intl", "ember-intl/macros"], function (_exports, _intl, _macros) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    Service: true
  };
  Object.defineProperty(_exports, "Service", {
    enumerable: true,
    get: function () {
      return _intl.default;
    }
  });
  Object.keys(_macros).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _macros[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function () {
        return _macros[key];
      }
    });
  });
});